import { z } from 'zod';

export const getScenarioBaseObject = (t: any) =>
  z.object({
    vendorIdList: z.array(z.string()).min(1, t('onboarding.fields.errors.selectOrigin', 'Select origin')),
    customerId: z.string().min(1, t('onboarding.fields.errors.selectOrigin', 'Select origin')),
    vendorId: z.string().min(1, t('onboarding.fields.errors.selectDestination', 'Select destination')),
    invoicingConcept: z.enum(['infrastructure', 'licenses', 'service', 'support'], {
      message: t('onboarding.fields.errors.invoicingConcept', 'Select a concept'),
    }),

    invoicingCurrency: z.string(),
    sellThroughLocalPartner: z.boolean(),
    partnerMargin: z
      .number({
        message: t('onboarding.fields.errors.validMargin', 'Enter a valid margin'),
      })
      .min(0)
      .max(100),

    invoicingAmount: z
      .number({
        message: t('onboarding.fields.errors.validAmount', 'Enter a valid amount'),
      })
      .positive(t('onboarding.fields.errors.validAmount', 'Enter a valid amount')),
    localCurrency: z.string().trim().toUpperCase(),
    selectedScenarios: z
      .array(z.string())
      .min(1, t('onboarding.fields.errors.selectAtLeastOneScenario', 'Select at least one scenario')),
  });

export const getOnboardingSummarySchema = (t: any) =>
  getScenarioBaseObject(t)
    .omit({
      partnerMargin: true,
      sellThroughLocalPartner: true,
      selectedScenarios: true,
    })
    .superRefine((data, ctx) => {
      // origin != destination
      if (data.customerId && data.vendorId && data.customerId === data.vendorId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['vendorId'],
          message: t('onboarding.fields.errors.differentOriginDestination', 'Origin and destination must be different'),
        });
      }
    });

export const getScenarioSchema = (t: any) =>
  getScenarioBaseObject(t).superRefine((data, ctx) => {
    // origin != destination
    if (data.customerId && data.vendorId && data.customerId === data.vendorId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['vendorId'],
        message: t('onboarding.fields.errors.differentOriginDestination', 'Origin and destination must be different'),
      });
    }

    // partnerMargin required if partner = true
    if (data.sellThroughLocalPartner && (data.partnerMargin == null || Number.isNaN(data.partnerMargin))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['partnerMargin'],
        message: t('onboarding.fields.errors.partnerMarginRequired', 'Partner margin is required'),
      });
    }
  });

export type ScenarioFormValues = z.infer<ReturnType<typeof getScenarioSchema>>;
